import React from 'react';

import Breadcrumb, { BreadcrumbItem } from 'view/section/Breadcrumb/Breadcrumb';
import { CardNumerico } from 'view/component/Cards/CardNumerico/CardNumerico';
import { AiOutlinePlus } from "react-icons/ai";
import NotificationDirectIcon from '@atlaskit/icon/glyph/notification-direct';
import PageIcon from '@atlaskit/icon/glyph/page';
import { BotaoCard } from 'view/component/Cards/BotaoCard/BotaoCard';

import { Destaque, CorDestaque } from 'view/component/Destaque/Destaque';
import { PainelCards, ItemPainel } from 'view/component/Cards/PainelCards/PainelCards';
import { IoMdStarHalf } from 'react-icons/io';
import { H2 } from 'view/component/Tipografia/Texto';
import styled from 'styled-components';
import { Spacing } from 'styles/theme/Tema';

import './inicial-page.css'
import { Conteudo } from 'view/section/Conteudo/Conteudo';

export const InicialPage: React.FunctionComponent = () => {

  return (
    <>
      <Breadcrumb>
        <BreadcrumbItem href="/">Início</BreadcrumbItem>
        <BreadcrumbItem>Minha página</BreadcrumbItem>
      </Breadcrumb>

      <Conteudo className="inicial-page">
        <section>
          <H2>Informações</H2>
          <Container>
            <PainelCards>
              <ItemPainel>
                <CardNumerico
                  textoSuperior="Já foram atendidas"
                  textoCentral={<Destaque cor={CorDestaque.Azul} >10<abbr title="milhões">M</abbr></Destaque>}
                  textoInferior={<>solicitações pela <abbr title="Secretaria de Tecnologia da Informação">STI</abbr></>}
                />
              </ItemPainel>
              <ItemPainel>
                <CardNumerico
                  textoSuperior="Você abriu"
                  textoCentral={<Destaque cor={CorDestaque.Verde} >27</Destaque>}
                  textoInferior={<>solicitações, <span style={{color: 'var(--color-red-300)'}}>y%</span> <abbr title="tarefas não fechadas">não finalizadas</abbr></>}
                />
              </ItemPainel>
              <ItemPainel>
                <CardNumerico
                  textoSuperior="São abertas mais de"
                  textoCentral={<Destaque cor={CorDestaque.Azul}>3 mil</Destaque>}
                  textoInferior={<>solicitações por mês</>}
                />
              </ItemPainel>
            </PainelCards>
          </Container>
        </section>

        <section>
          <H2>Acesso rápido</H2>
          <Container>
            <PainelCards>
              <ItemPainel>
                <BotaoCard navlink={{to: '/solicitacoes/new'}} icone={AiOutlinePlus}>Criar nova solicitação</BotaoCard>
              </ItemPainel>
              <ItemPainel>
                <BotaoCard navlink={{to: '/solicitacoes'}} icone={PageIcon} iconeProps={{size: 'xlarge'}}>Minhas solicitações<div>(<Destaque>25</Destaque> a responder)</div></BotaoCard>
              </ItemPainel>
              <ItemPainel>
                <BotaoCard navlink={{to: '/solicitacoes'}} icone={IoMdStarHalf} iconeProps={{size: 'xlarge'}}>Solicitações a avaliar<div>(<Destaque>14</Destaque> pendentes)</div></BotaoCard>
              </ItemPainel>
              <ItemPainel>
                <BotaoCard navlink={{to: '/notificacoes'}} icone={NotificationDirectIcon} iconeProps={{size: 'xlarge'}}>Notificações <div>(<Destaque>+100</Destaque> não lidas)</div></BotaoCard>
              </ItemPainel>
              <ItemPainel>
                <BotaoCard navlink={{to: '/prioridades'}} icone={NotificationDirectIcon} iconeProps={{size: 'xlarge'}}>Prioridades <div>(<Destaque>+100</Destaque> não lidas)</div></BotaoCard>
              </ItemPainel>
            </PainelCards>
          </Container>
        </section>
      </Conteudo>
    </>
  )
}


const Container = styled.div`
  & ul {
    margin-top: ${Spacing.unit}px;
    margin-bottom: ${Spacing.unit*2}px;
    background: ${p => p.theme.background.nivel_1};
    border-radius: ${Spacing.unit*2}px;
  }
`;
